export const UNITS = {
	squareMeter: "m²",
	kilowatt: "kW",
	cubicCentimeter: "ccm",
	kilogram: "kg",
} as const;

export type Unit = (typeof UNITS)[keyof typeof UNITS];
